import SectionPricingFeatureTable from "./SectionPricingFeatureTable";
export default SectionPricingFeatureTable;
